import CollectionProvider from './CollectionProvider';
import ExperimentProvider from './ExperimentProvider';
import LocalizationProvider from './LocalizationProvider';
import StoreProvider from './StoreProvider';
import ThemeProvider from './ThemeProvider';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <StoreProvider>
      <ExperimentProvider>
        <CollectionProvider>
          <LocalizationProvider>
            <ThemeProvider>{children}</ThemeProvider>
          </LocalizationProvider>
        </CollectionProvider>
      </ExperimentProvider>
    </StoreProvider>
  );
}
